import { render, staticRenderFns } from "./AppInvestorHeader.vue?vue&type=template&id=2438404e&scoped=true&"
import script from "./AppInvestorHeader.vue?vue&type=script&lang=js&"
export * from "./AppInvestorHeader.vue?vue&type=script&lang=js&"
import style0 from "./AppInvestorHeader.vue?vue&type=style&index=0&id=2438404e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2438404e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VAppBar,VAppBarNavIcon,VBtn,VIcon,VImg,VList,VListItem,VListItemTitle,VMenu})
